@if (errorData; as data) {
  <div class="min-h-screen flex items-center justify-center bg-gray-100">
    <div
      class="bg-white rounded-2xl shadow-lg p-8 md:p-12 max-w-5xl w-full flex flex-col md:flex-row items-center gap-10"
      >
      <div class="flex-1 flex justify-center">
        <img
          [src]="data.image"
          [alt]="data.title || 'Error'"
          class="max-h-64 object-contain"
          />
      </div>
      <div class="flex-1 text-center md:text-left">
        <h1 class="text-6xl font-bold text-slate900 mb-2">
          {{ errorCode }}
        </h1>
        <h2 class="text-xl font-semibold text-gray-800 mb-2">
          {{ data.title }}
        </h2>
        <p class="text-gray-500 mb-6 leading-relaxed max-w-md">
          {{ data.message }}
        </p>
        <button
          (click)="onActionClick()"
          class="wm-button-primary"
          >
          {{ data.buttonText }}
        </button>
      </div>
    </div>
  </div>
}
